const GAP = 16;
const MARGIN = 8;
const ANCHOR_FROM_TOP = 22;
const POINTER_INSET = 12;

// Card position in map-container pixels: right of the anchor, else left of it,
// kept inside the free map area (below the app bar, above the slider, beside panels).
export function placeInfoCard({ anchor, size, area }) {
  const left = area.left + MARGIN;
  const right = area.right - MARGIN;
  const top = area.top + MARGIN;
  const bottom = area.bottom - MARGIN;
  const { w, h } = size;

  const rightX = anchor.x + GAP;
  const leftX = anchor.x - GAP - w;
  let side;
  let x;
  if (rightX + w <= right) {
    side = "right";
    x = rightX;
  } else if (leftX >= left) {
    side = "left";
    x = leftX;
  } else {
    side = right - anchor.x >= anchor.x - left ? "right" : "left";
    x = Math.max(left, Math.min(side === "right" ? rightX : leftX, right - w));
  }

  const y = Math.max(top, Math.min(anchor.y - ANCHOR_FROM_TOP, bottom - h));
  const pointerY = anchor.y - y;
  const besideAnchor = side === "right" ? x >= anchor.x : x + w <= anchor.x;
  const pointer =
    besideAnchor && pointerY >= POINTER_INSET && pointerY <= h - POINTER_INSET
      ? { side, y: pointerY }
      : null;

  return { left: x, top: y, pointer };
}
